import { render, staticRenderFns } from "./DynamicContainerProvider.vue?vue&type=template&id=65696a98&"
import script from "./DynamicContainerProvider.vue?vue&type=script&lang=ts&"
export * from "./DynamicContainerProvider.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports